import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";
import { WineColorEnum } from "@/constants/enums/wineColor.enum";

export const productFormSchema = z.object({
  description: z
    .string({ required_error: i18nMessage("boCatalog:productForm.descriptionRequired") })
    .min(1, i18nMessage("boCatalog:productForm.descriptionRequired")),
  descriptionPelican: z
    .string({ required_error: i18nMessage("boCatalog:productForm.descriptionPelicanRequired") })
    .min(1, i18nMessage("boCatalog:productForm.descriptionPelicanRequired")),
  countryOfOrigin: z
    .string({ required_error: i18nMessage("boCatalog:productForm.countryOfOriginRequired") })
    .min(1, i18nMessage("boCatalog:productForm.countryOfOriginRequired")),
  harmonizedCode: z
    .string({ required_error: i18nMessage("boCatalog:productForm.harmonizedCodeRequired") })
    .min(4, i18nMessage("boCatalog:productForm.harmonizedCodeMinLength")),
  color: z.nativeEnum(WineColorEnum, {
    message: i18nMessage("boCatalog:productForm.colorRequired"),
  }),
  volume: z
    .number({ required_error: i18nMessage("boCatalog:productForm.volumeRequired") })
    .min(0, i18nMessage("boCatalog:productForm.volumePositive")),
});

export type ProductFormData = z.infer<typeof productFormSchema>;

export const productUsaFormSchema = z.object({
  description: z
    .string({ required_error: i18nMessage("boCatalog:productForm.descriptionRequired") })
    .min(1, i18nMessage("boCatalog:productForm.descriptionRequired")),
  descriptionPelican: z
    .string({ required_error: i18nMessage("boCatalog:productForm.descriptionPelicanRequired") })
    .min(1, i18nMessage("boCatalog:productForm.descriptionPelicanRequired")),
  countryOfOrigin: z
    .string({ required_error: i18nMessage("boCatalog:productForm.countryOfOriginRequired") })
    .min(1, i18nMessage("boCatalog:productForm.countryOfOriginRequired")),
  harmonizedCode: z
    .string({ required_error: i18nMessage("boCatalog:productForm.harmonizedCodeRequired") })
    .min(4, i18nMessage("boCatalog:productForm.harmonizedCodeMinLength")),
  color: z.nativeEnum(WineColorEnum, {
    message: i18nMessage("boCatalog:productForm.colorRequired"),
  }),
  alcoholPercentage: z
    .number({ required_error: i18nMessage("boCatalog:productForm.alcoholPercentageRequired") })
    .min(0, i18nMessage("boCatalog:productForm.alcoholPercentagePositive")),
  volume: z
    .number({ required_error: i18nMessage("boCatalog:productForm.volumeRequired") })
    .min(0, i18nMessage("boCatalog:productForm.volumePositive")),
  ttbNumber: z
    .string({ required_error: i18nMessage("boCatalog:productForm.ttbNumberRequired") })
    .min(1, i18nMessage("boCatalog:productForm.ttbNumberRequired")),
  importerId: z
    .string({ required_error: i18nMessage("boCatalog:productForm.importerRequired") })
    .min(1, i18nMessage("boCatalog:productForm.importerRequired")),
  clientId: z.string().optional().or(z.literal("")),
  colaId: z
    .string({ required_error: i18nMessage("boCatalog:productForm.colaRequired") })
    .min(1, i18nMessage("boCatalog:productForm.colaRequired")),
});

export type ProductUsaFormData = z.infer<typeof productUsaFormSchema>;
